const COLORS = { food: "#F97316", body: "#8B5CF6", scan: "#16A34A" };

const PHRASE_COLORS = { Food: COLORS.food, Body: COLORS.body, Scan: COLORS.scan };

export const renderBrandPhrases = (text) => {
  if (typeof text !== "string") return text;
  return text.split(/(WhatThe\? (?:Food|Body|Scan))/g).map((part, i) => {
    const word = part.startsWith("WhatThe? ") ? part.slice(9) : null;
    if (word && PHRASE_COLORS[word]) {
      return (
        <span key={i}>
          WhatThe<span style={{ color: PHRASE_COLORS[word] }}>?</span> {word}
        </span>
      );
    }
    return part;
  });
};

export const BrandLabel = ({ text, className, variant }) => {
  const idx = typeof text === "string" ? text.indexOf("?") : -1;
  if (idx === -1) return <span className={className}>{text}</span>;

  const lower = text.toLowerCase();
  const color = variant
    ? COLORS[variant] || COLORS.scan
    : lower.includes("body")
    ? COLORS.body
    : lower.includes("food")
    ? COLORS.food
    : COLORS.scan;

  return (
    <span className={className}>
      {text.slice(0, idx)}
      <span style={{ color }}>?</span>
      {text.slice(idx + 1)}
    </span>
  );
};
